import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { countriesService } from 'projects/shop/src/app/modules/home/services/countries.service';
import { BrowserService } from '../services/browser.service';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';
import { SelectRegionalCountry } from 'projects/shop/src/app/layout/navbar/components/navbar-header/partials/nav-regional/store/regional-setting.selectors';

function toSnakeCase(str: string | null | undefined): string {
  if (!str || typeof str !== 'string') return '';
  return str.toLowerCase().trim().replace(/\s+/g, '_');
}

function getCountryCode(): string {
  const store = inject(Store);
  const country = store.selectSignal(SelectRegionalCountry)();

  if (!country) return 'eg'; // fallback آمن لو الـ Store لسه فاضي (SSR أو قبل ما الـ effect يجيب الداتا)

  return toSnakeCase(country);
}

export const DevAccessInterceptor: HttpInterceptorFn = (request, next) => {
  const countryService = inject(countriesService);
  const browser = inject(BrowserService);
  const languageService = inject(LanguageService);

  let req = request;

  if (request.url.includes('-dev.')) {
    req = request.clone({
      headers: request.headers.set('X-API-Key', 'C4G_X9mK7pL2nQ5vB8rT4wY1aZ6cF3jH0sD_2025_DEV_ACCESS')
    });
  }

  if (req.url.includes('suggestions')) {
    const countryKey = getCountryCode();
    const countryCode = countryService?.countryCodes?.[countryKey] || 'EG';

    const clonedReq = req.clone({
      headers: req.headers.set('X-User-Country', countryCode)
    });

    return next(clonedReq);
  } else {
    return next(req);
  }
};